import PayWithPaystack from "../components/checkout/PayWithPaystack";

const PayWithPaystackPage = () => {
    return ( 
        <div>
            <PayWithPaystack />
        </div>
     );
}
 
export default PayWithPaystackPage;